module.exports = __webpack_public_path__ + "static/tgLogoWhite-f708b3db0c5ef1a94e4d6836278fc7d3.svg";